import styled, { css } from 'styled-components/macro';

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.s};
    display: flex;
    flex-direction: column;
    gap: 6px;
    background-color: ${theme.colors.gray[50]};
    border-radius: ${theme.radiuses.s};
  `}
`;
